import React from 'react';
import PropTypes from 'prop-types';
import { TripTypeSelector } from './TripTypeSelector';
import { TripType, TripTypeProp, TripTypePropDefault } from '../../models';
import { TripTypeItemDesktop } from './TripTypeItemDesktop';

export const TripTypeSelectorDesktopInner = ({ value, onChange, isRailsSearcher }) => {
    const tripTypes = Object.values(TripType);
    if (isRailsSearcher) {
        tripTypes.splice(tripTypes.indexOf(TripType.MULTIPLE), 1);
    }
    return (
        <div className="odf-row-inline odf-row-nogutter">
            {tripTypes.map((tripType) => (
                <TripTypeItemDesktop
                    key={tripType}
                    onChange={onChange}
                    selected={value}
                    tripType={tripType}
                />
            ))}
        </div>
    );
};

TripTypeSelectorDesktopInner.propTypes = {
    value: TripTypeProp,
    onChange: PropTypes.func.isRequired,
};

TripTypeSelectorDesktopInner.defaultProps = {
    value: TripTypePropDefault,
};

export const TripTypeSelectorDesktop = ({ isRailsSearcher }) => (
    <TripTypeSelector render={(value, onChange) => (
        <TripTypeSelectorDesktopInner
            onChange={onChange}
            value={value}
            isRailsSearcher={isRailsSearcher}
        />
    )}
    />
);
